import Vue from 'vue';
import VueRouter from 'vue-router';

import HomePage from '@/views/HomePage/HomePage.vue';
import NotFoundPage from '@/views/NotFoundPage/NotFoundPage.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'HomePage',
    component: HomePage,
    meta: {
      layout: 'default',
      requiresAuth: false
    }
  },
  {
    path: '/offers',
    name: 'MyOffers',
    component: () => import(/* webpackChunkName: "motor" */ '@/views/MyOffers/MyOffers.vue'),
    meta: {
      layout: 'default',
      requiresAuth: false
    }
  },
  {
    path: '/contracts',
    name: 'MyContracts',
    component: () => import(/* webpackChunkName: "motor" */ '@/views/MyContracts/MyContracts.vue'),
    meta: {
      layout: 'default',
      requiresAuth: true
    }
  },
  {
    path: '/motor',
    name: 'Motor',
    component: () => import(/* webpackChunkName: "motor" */ '@/views/Motor/Motor.vue'),
    meta: {
      layout: 'default',
      requiresAuth: false
    }
  },
  {
    path: '/motor/:id',
    name: 'MotorDisplay',
    component: () => import(/* webpackChunkName: "motor" */ '@/views/Offer/MotorAdmin.vue'),
    meta: {
      layout: 'default',
      requiresAuth: false
    }
  },
  {
    path: '/travel',
    name: 'Travel',
    component: () => import(/* webpackChunkName: "travel" */ '@/views/Travel/Travel.vue'),
    meta: {
      layout: 'default',
      requiresAuth: false
    }
  },
  {
    path: '/home',
    name: 'Home',
    component: () => import(/* webpackChunkName: "home" */ '@/views/Home/Home.vue'),
    meta: {
      layout: 'default',
      requiresAuth: false
    }
  },
  {
    path: '/driver',
    name: 'Driver',
    component: () => import(/* webpackChunkName: "driver" */ '@/views/Driver/Driver.vue'),
    meta: {
      layout: 'default',
      requiresAuth: false
    }
  },
  {
    path: '/hunter',
    name: 'Hunter',
    component: () => import(/* webpackChunkName: "hunter" */ '@/views/Hunter/Hunter.vue'),
    meta: {
      layout: 'default',
      requiresAuth: false
    }
  },
  {
    path: '/about',
    name: 'About',
    component: () => import(/* webpackChunkName: "about" */ '@/views/About.vue'),
    meta: {
      layout: 'login',
      requiresAuth: false
    }
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import(/* webpackChunkName: "login" */ '@/views/Login/Login.vue'),
    meta: {
      layout: 'login',
      requiresAuth: false
    }
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import(/* webpackChunkName: "login" */ '@/views/Register/Register.vue'),
    meta: {
      layout: 'login',
      requiresAuth: false
    }
  },
  {
    path: '/cookies',
    name: 'CookiesManagement',
    component: () => import(/* webpackChunkName: "cookies" */ '@/views/CookiesManagement/CookiesManagement.vue'),
    meta: {
      layout: 'login',
      requiresAuth: false
    }
  },
  {
    path: '/translations',
    name: 'Translations',
    component: () => import(/* webpackChunkName: "translations" */ '@/views/Translations/Translations.vue'),
    meta: {
      layout: 'login',
      requiresAuth: false
    }
  },
  {
    path: '*',
    component: NotFoundPage,
    meta: {
      layout: 'login',
      requiresAuth: false
    }
  }
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});

export default router;
